
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IExactVatCodeOverride } from "@/services/accountant-service";

export default Vue.extend({
	data() {
		return {
			rows: [] as IExactVatCodeOverride[]
		};
	},
	props: {
		overrides: {
			type: Array as () => IExactVatCodeOverride[],
			default: () => []
		},
		vatCodeItems: {
			type: Array as () => ISelectItem<string>[],
			default: () => []
		},
		regimeItems: {
			type: Array as () => ISelectItem<number>[],
			required: true
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		addRow() {
			this.rows.push({regime: this.defaultRegime(), rate: 21, code: ""});
		},
		defaultRegime():number {
			return this.regimeItems.length ? this.regimeItems[0].value : 1;
		},
		apply() {
			let cleaned = this.rows
				.filter(o => !!o.code)
				.map(o => ({regime: Number(o.regime) || 0, rate: Number(o.rate) || 0, code: o.code}));
			this.$emit("save", cleaned);
		}
	},
	created() {
		let rows = this.overrides.map(o => ({...o}));
		if (!rows.length) {
			rows.push({regime: this.defaultRegime(), rate: 21, code: ""});
		}
		this.rows = rows;
	},
	i18nEx: {
		componentPrefix: "components.accountant-DossierIntegrationForm"
	}
});
